<div class="lobby_group--header swiper_header lobby-header--{{lobbyNameString}}" >
    <h2 class="lobby_group--title">{{gameGroup.name}}</h2>
    <div class="lobby_group--nav lobby_group--nav-show" *ngIf="!disableViewMore">
        <a class="site-btn lobby_group--button" [routerLink]="goToCategory(gameGroup)">{{'gamingComp.gaming30' | translate}}</a>
        <div class="swiper-button-prev swiper-button-disabled swiper-button-prev--{{lobbyNameString}}"></div>
        <div class="swiper-button-next swiper-button-disabled swiper-button-next--{{lobbyNameString}}"></div>
    </div>
</div>

<div class="swiper swiper-container lobby-swiper lobby_group--games clearfix lobby-swiper--{{lobbyNameString}}">
    <div class="swiper-wrapper">
        <ng-container *ngFor="let game of gameGroupDetails | slice:start:end" >
            <div class="swiper-slide swiper_card" *ngIf="(game.gameType === 'live_casino' && liveTableData[game.pristineGameId]) || game.gameType !== 'live_casino'">
                <div class="slot_rect_card">
                    <app-lobby-game-card [game]="game" [isFavourite]="favItemObj[game.gameCode]"
                        [liveGameDetails]="liveTableData[game.pristineGameId]">
                    </app-lobby-game-card>
                </div>
            </div>
        </ng-container>
    </div>
</div>